// extracted by mini-css-extract-plugin
export default {"customerType":"CustomerTypeSwitch_customerType__QAgP7"};